import React from 'react';
import RestInputItem from 'components/RestInput/RestInputItem';
import RestEditor from 'components/RestInput/RestEditor';
import RestSelect from 'components/RestInput/RestSelect';
import { useSelector } from 'react-redux';

const PlatformsForm = () => {
  const productCatalogs = useSelector(
    (state) => state.config?.data?.productType,
  );

  return (
    <div>
      <RestInputItem source="name" header="platforms.name" />
      <RestEditor source="description" header="platforms.description" />
      <RestInputItem
        source="productCatalogId"
        header="platforms.productCatalogId"
      />
      <RestSelect
        required
        source="productCatalogId"
        header="orders.productCatalogId"
        titleProp="name"
        valueProp="id"
        resourceData={productCatalogs}
        ruleType="array"
      />
    </div>
  );
};

PlatformsForm.propTypes = {};

export default PlatformsForm;
